var common = require("../utiles/common");
var layUtils = require("../utiles/layUtils");
var metaTypeUtils = require("../utiles/metaTypeUtils");
var metaService = require("../services/metaService")

module.exports = {
    register: function () {
        document.createElement('q-form')
        ko.components.register('q-form', {
            viewModel: function (params) {
                var $this = this;
                $this.formData = metaService.loadForm({
                    formId:params.app.formId,
                })
                console.log($this.formData);
                var formDefine = JSON.parse($this.formData.formDefine);
                $this.result = metaTypeUtils.buildFormData({
                    qualifyName:$this.formData.formDataType,
                    submitText:params.app.submitText,
                    data:$this.formData.formData?JSON.parse($this.formData.formData):{},
                    formDefine:formDefine,
                    callback:function(data){
                        console.log(data)
                        common.fetch("/auth/action/execute", {
                            type: "POST",
                            data: JSON.stringify({
                                actionId:params.app.actionId,
                                data:data
                            }),
                            handleError: function (data) {
                                $("img.verifyImg").attr("src", "/auth/verification/img?type=LOGIN&random=" + Math.random());
                            },
                            success: function (result) {
                                if(params.app.callback){
                                    params.app.callback();
                                }else{
                                    layUtils.msg("表单提交成功!");
                                }
                                return false;
                            }
                        })
                    }
                });
            },
            template: require("./QForm.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/QForm.js
// module id = 88
// module chunks = 0